{ Jadelet, Modal } from @danielx/dui
Observable from @danielx/observable

{ writePracticeMetadata } from ../lib/midi/practice-metadata.civet
{ autoPracticeMetadata } from ../lib/midi/auto-practice.civet

// The bundled song collection: MIDIs shipped in www/songs/, listed by
// songs/manifest.json, ready to practice or play without hunting for files.
// Opened from the mode modal and by entering practice/game on an EMPTY song
// (practice.civet enterMode) — the target mode rides along so picking a
// piece drops you straight into the mode that asked. Each piece is
// auto-configured on load (lib/midi/auto-practice.civet): the manifest
// carries identity and credit, the analysis finds the sections and the part.
Template := Jadelet.exec """
  section.song-picker.song-collection
    h2 🎵 Song Collection
    button.close(click=@close) X
    p Built-in pieces, configured automatically — pick one to practice or play. Credits ride along in each song's title bar.
    table
      thead
        tr
          th Title
          th Credit
      tbody
        @items
"""

RowTemplate := Jadelet.exec """
  tr(@click)
    td @title
    td.credit @credit
"""

type ManifestEntry =
  file: string
  title: string
  credit?: string
  difficulty?: number

export SongCollection := (player: Player) ->
  entries := Observable [] as ManifestEntry[]
  loaded .= false
  let target: ("practice" | "game")?

  load := ->
    return if loaded
    loaded = true
    try
      res := await fetch "songs/manifest.json"
      {songs} := await res.json() as {songs: ManifestEntry[]}
      entries songs
    catch
      loaded = false

  play := (entry: ManifestEntry) ->
    await player.confirmUnsaved()
    Modal.hide()

    res := await fetch `songs/${entry.file}`
    throw new Error `${entry.file}: ${res.status}` unless res.ok
    // fromBlob sniffs MThd from the bytes, so the server's content type
    // doesn't matter; it inits the song and pushes the import undo state
    await player.fromBlob await res.blob()

    if meta := autoPracticeMetadata player.song
      meta.title = entry.title
      meta.difficulty = entry.difficulty if entry.difficulty?
      writePracticeMetadata player.song, meta
    player.song.title entry.title
    player.pushState player.getState()

    if target
      player.enterMode target
      target = undefined

  player.showSongCollection = (mode?: "practice" | "game") ->
    target = mode
    load()
    Modal.show self.element

  self :=
    close: -> Modal.hide()
    items: ->
      entries().map (entry) ->
        RowTemplate
          title: entry.title
          credit: entry.credit ?? ""
          click: -> play entry

    element: null as! HTMLElement

  self.element = Template self

  return self

export default SongCollection
